import { render, staticRenderFns } from "./SubCategoriesComponent.vue?vue&type=template&id=9c36f0ba&"
import script from "./SubCategoriesComponent.vue?vue&type=script&lang=js&"
export * from "./SubCategoriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports